
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/past-events",
      function () {
        return require("private-next-pages/past-events/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/past-events"])
      });
    }
  